const time = {
    "周": "สัปดาห์",
    "天": "วัน",
    "小时": "ชั่วโมง",
    "分钟": "นาที",
    "刚刚": "เมื่อกี้",
    "前": "ก่อน",
    "昨天": "เมื่อวาน",
    "星期一": "วันจันทร์",
    "星期二": "วันอังคาร",
    "星期三": "วันพุธ",
    "星期四": "วันพฤหัสบดี",
    "星期五": "วันศุกร์",
    "星期六": "วันเสาร์",
    "星期日": "วันอาทิตย์"
}

export default time;